import React from 'react'
import {motion} from 'framer-motion'

const StripePaymentButton = ({ 
  planName = "Cycle CEO",
  amount = 5,
  currency = "gbp",
  paymentLink = "https://buy.stripe.com/00wbJ18S06EwbMR3Fwgw005",
  className = "",
  children 
}) => {
  const handlePayment = () => {
    // Open Stripe payment link in new tab
    window.open(paymentLink, '_blank')
  }

  return (
    <motion.button
      onClick={handlePayment}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`gold-bg text-white py-4 px-6 rounded-lg font-medium hover:opacity-90 transition-opacity ${className}`}
    >
      {children || `Get ${planName} - £${amount}/${currency === 'gbp' ? 'month' : currency}`}
    </motion.button>
  )
}

export default StripePaymentButton